import type { Tier, Unknown } from '../constants/vocabulary';
import type { LibraryTypeSummary, NodeTypeOption } from '../types/contract';

export type NameIndex = ReadonlyMap<string, string>;

export type TierIndex = ReadonlyMap<string, Tier | Unknown>;

export const nameIndexOf = (options: readonly NodeTypeOption[]): NameIndex => new Map(options.map((option) => [option.code, option.name]));

export const tierIndexOf = (summaries: readonly LibraryTypeSummary[]): TierIndex => new Map(summaries.map((summary) => [summary.code, summary.tier]));

export const typeNameOf = (names: NameIndex | undefined, code: string): string => names?.get(code) ?? code;
